import { useState } from 'react';
import './CardSlot.css';

export default function CardSlot({
  row,
  index,
  onDrop,
  onTap,
  highlighted = false,
  violation = false,
  children, // Card component if occupied
}) {
  const [dragOver, setDragOver] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    try {
      const card = JSON.parse(e.dataTransfer.getData('text/plain'));
      onDrop?.(card, row, index);
    } catch { /* ignore invalid drops */ }
  };

  const handleClick = () => {
    if (!children) onTap?.(row, index);
  };

  const classes = [
    'card-slot',
    dragOver && 'card-slot--drag-over',
    highlighted && 'card-slot--highlighted',
    violation && 'card-slot--violation',
    !children && 'card-slot--empty',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      {children}
    </div>
  );
}
